import type { WorkshopDetailHeaderProps } from './workshopDetailHeader.types';
import { WorkshopHeaderDraftActions } from './WorkshopHeaderDraftActions';

/** Discard + Publish on a draft that isn't being edited; nothing otherwise. */
export function WorkshopHeaderActions(props: WorkshopDetailHeaderProps) {
  if (props.readOnly || props.editing || props.workshop.lifecycle !== 'draft') return null;
  return (
    <WorkshopHeaderDraftActions
      discarding={props.discarding}
      publishing={props.publishing}
      onPublish={props.onPublish}
      onDiscard={props.onDiscard}
    />
  );
}
